import { render } from "./EmptyTableDeactiveAction.vue?vue&type=template&id=10007bba&scoped=true"
const script = {}

import "./EmptyTableDeactiveAction.vue?vue&type=style&index=0&id=10007bba&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10007bba"]])

export default __exports__